import { range } from "../../Utils/Numbers";
import { Guid } from "../../Utils/Guid";
import { BaseComponent } from "../BaseComponent";
import { SelectEditorFactory } from "../Factories/SelectEditorFactory";
import * as React from "react";
import { Content } from "../Resources/Content";

export interface IPagerDropdownProps extends React.Props<PagerDropdown> {
    onChange: (pageIndex: number) => void;

    currentPage: number;

    numberOfPages: number;
}

export interface IPagerDropdownState {}

export class PagerDropdown extends BaseComponent<IPagerDropdownProps, IPagerDropdownState> {
    private _selectId = Guid.getNext();

    constructor(props: IPagerDropdownProps) {
        super(props);
        this.state = {};
    }

    public render(): JSX.Element {
        const PagesDropdown = SelectEditorFactory.create<number>();
        const numberOfPages = this.props.numberOfPages === 0 ? 1 : this.props.numberOfPages;

        return (
            <div className="row narrow-gutter">
                <div className="col-sm-auto col-middle">
                    <label className="block mt-12 mb-12" htmlFor={this._selectId}>
                        {Content.Go_to_page_label}
                    </label>
                </div>
                <div className="col-auto">
                    <PagesDropdown
                        id={this._selectId}
                        cssWrapper="mb-0"
                        onChange={(value) => this.props.onChange(value)}
                        selected={this.props.currentPage}
                        getText={(value: number) => value.toString()}
                        options={range(1, numberOfPages + 1)}
                    />
                </div>
            </div>
        );
    }
}
